var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row task-text"},[_vm._v(" "+_vm._s(_vm.item.displayValue)+"= "),_c('div',{staticClass:"solution"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }